import { inputTypes } from 'components/common/FormElements/Input'
import { getTireSizesOptions, getEngineOptions } from './helpers'
import {
  VEHICLE_NICKNAME,
  LICENCE_NAME,
  VEHICLE_MILEAGE,
  LICENCE_MAX_LENGTH,
  STATE_NAME
} from 'constant'
import { VEHICLE_TIRES, VEHICLE_ENGINE } from './constants'

export default ({
  vehicleCompatibleSizes,
  userVehicleDetails,
  vehicleEngineType,
  stateOptions
}) => ({
  nickname: {
    label: 'Vehicle Nickname (optional)',
    name: VEHICLE_NICKNAME,
    'data-at-vehicle-personalization-nickname': true
  },
  mileage: {
    label: 'Mileage',
    name: VEHICLE_MILEAGE,
    'data-at-editvehiclemodal-mileage': true
  },
  engine: {
    label: 'Engine Size',
    name: VEHICLE_ENGINE,
    inputType: inputTypes.SELECT_DROPDOWN_INPUT,
    options: getEngineOptions(vehicleEngineType),
    isSearchable: false
  },
  tires: {
    label: 'Tire Size',
    name: VEHICLE_TIRES,
    inputType: inputTypes.SELECT_DROPDOWN_INPUT,
    options: getTireSizesOptions({ userVehicleDetails, vehicleCompatibleSizes }),
    isSearchable: false
  },
  licencePlateNumber: {
    name: LICENCE_NAME,
    maxLength: LICENCE_MAX_LENGTH,
    label: 'License Plate # (optional)'
  },
  state: {
    label: 'Select State',
    name: STATE_NAME,
    inputType: inputTypes.SELECT_DROPDOWN_INPUT,
    options: stateOptions,
    isSearchable: false
  }
})
